<div class="d-flex flex-column flex-column-fluid">
  <div class="container-fluid">
    <!-- Patient Header Informations -->
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="container-fluid mt-1 ps-0">
            <div class="card d-flex p-4 px-7">
              <div class="row align-items-center">
                <div class="col-md-6 mt-2">
                  <h5 class="card-subtitle">
                    {{ patientHeaderInformations?.name || "-" }}
                    {{ patientHeaderInformations?.lastName || "-" }},
                    {{ patientHeaderInformations?.age || "-" }},
                    {{ patientHeaderInformations?.gender[0] || "-" }}
                  </h5>
                </div>
                <div class="col-md-6">
                  <div class="app-navbar-item ms-1 new-consultation">
                    <button
                      *ngIf="
                        patientHeaderInformations?.patientStatus >
                          caseStatus.WaitingConsultation &&
                        patientHeaderInformations?.patientStatus <
                          caseStatus.Closed
                      "
                      type="button"
                      class="btn p-3 btn-dark btn-sm me-3"
                      (click)="closeConsultation()"
                    >
                      {{ "closeConsultation" | translate }}
                    </button>
                    <button
                      [routerLink]="[
                        '/patient/new-patient-case-card',
                        patientId
                      ]"
                      type="button"
                      class="btn btn-sm p-3 btn-primary fw-bold"
                    >
                      {{ "newConsultation" | translate }}
                      <i class="fa-solid fa-chevron-right fs-12"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Patient Case Informations -->
    <div class="container-fluid mt-3">
      <div class="row">
        <div class="col">
          <div class="container-fluid ps-0">
            <div class="card">
              <div class="container-fluid">
                <div class="container-fluid left-tabs py-6 px-5 mx-0">
                  <!-- Tabs -->
                  <ul
                    class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
                    role="tablist"
                  >
                    <li
                      *ngFor="let tab of tabs"
                      class="nav-item"
                      role="presentation"
                      [ngStyle]="{
                        display: tab.display
                      }"
                    >
                      <a
                        (click)="selectTab(tab)"
                        class="nav-link text-gray-800"
                        [ngClass]="{
                          'active': tab.active,
                        }"
                        data-bs-toggle="tab"
                        [href]="tab.href"
                        [attr.aria-selected]="tab.active"
                        tabindex="-1"
                        role="tab"
                        >{{ tab.name | translate }}</a
                      >
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <!-- Case Informations Tab Content -->
                    <div
                      class="tab-pane fade show active"
                      id="caseInformation"
                      role="tabpanel"
                    >
                      <app-case-information
                        [patientHeaderInformations]="patientHeaderInformations"
                        [diabetesCaseInformation]="diabetesCaseInformation"
                        [lifestyleProfile]="lifestyleProfile"
                        [consultationId]="consultationId"
                      />
                    </div>
                    <!-- AI Report Tab Content -->
                    <div class="tab-pane fade" id="aiReport" role="tabpanel">
                      <ng-container *ngIf="activeTabList.includes('aiReport')">
                        <app-ai-report [consultationId]="consultationId" />
                      </ng-container>
                    </div>
                    <!-- Consultation Report Tab Content -->
                    <div
                      class="tab-pane fade"
                      id="consultationReport"
                      role="tabpanel"
                    >
                      <ng-container
                        *ngIf="activeTabList.includes('consultationReport')"
                      >
                        <app-consultation-report
                          [consultationReportError]="consultationReportError"
                          [consultationId]="consultationId"
                        />
                      </ng-container>
                    </div>
                    <!-- Chat Tab Content -->
                    <div
                      class="tab-pane fade"
                      id="chatWithInternist"
                      role="tabpanel"
                    >
                      <ng-container
                        *ngIf="activeTabList.includes('chatWithInternist')"
                      >
                        <app-chat
                          [currentUser]="currentUser"
                          [patientHeaderInformations]="
                            patientHeaderInformations
                          "
                          [consultationId]="consultationId"
                          (patientInfoRequested)="
                            getPatientInformations($event)
                          "
                        />
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Consultation Timeline -->
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="container-fluid mt-3 pb-20 ps-0">
            <div class="card">
              <div class="container-fluid">
                <div class="row">
                  <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label fw-bold fs-3 mb-1">{{
                        "consultationTimeLine" | translate
                      }}</span>
                    </h3>
                  </div>
                  <div
                    *ngIf="
                      consultationTimeLines && consultationTimeLines?.length;
                      else noCase
                    "
                    class="container"
                  >
                    <div class="gantt-chart">
                      <div class="gantt-header">
                        <div></div>
                        <div></div>
                        <div *ngFor="let date of timeLineDates">
                          {{ date | date : "dd-MM-yyyy" }}
                        </div>
                      </div>
                      <div class="gantt-container">
                        <div
                          *ngFor="
                            let timeLine of consultationTimeLines;
                            let i = index
                          "
                          class="gantt-row cursor-pointer"
                          [class.selected-item]="selectedIndex === i"
                          (click)="selectItem(i, timeLine)"
                        >
                          <div
                            class="gantt-row-case"
                            [attr.data-id]="timeLine.createdDate"
                          >
                            <i
                              (click)="selectCase(timeLine, $event)"
                              class="fa-solid fa-pencil edit-icon"
                              title="Add related case"
                            ></i>
                            {{ "case" | translate }} {{ i + 1 }}
                          </div>
                          <div class="gantt-bar-container">
                            <div
                              class="gantt-bar"
                              [ngClass]="{
                                even: i % 2 === 0,
                                odd: i % 2 !== 0,
                                'status-high': timeLine.patientStatus > 2,
                                'status-low': timeLine.patientStatus <= 2
                              }"
                              [style.width.%]="calculateWidth(timeLine)"
                              [style.left.%]="
                                calculateLeftPosition(timeLine.createdDate)
                              "
                            >
                              {{ "case" | translate }} {{ i + 1 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noCase>
                    <div class="no-case-found">
                      {{ "noCaseToBeDisplayed" | translate }}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
